import { Injectable } from "@angular/core";

import { EntitetStatus } from "@dffedb/util";
import { EjendomsfaktorDefinition, EjendomsfaktorDefinitionDto, EjendomsfaktorMapper } from "@e-forsyning/common/ejendomsfaktor";

import { Opgave } from "../../model/opgave.model";
import { Arbejdsgang } from "../model/arbejdsgang.model";
import { EjendomsfaktorerData } from "./model/ejendomsfaktorer-data.model";

@Injectable({ providedIn: "root" })
export class ServicerapportEjendomsfaktorMapper {
    public constructor(private readonly ejendomsfaktorMapper: EjendomsfaktorMapper) {}

    public grupperEjendomsfaktorer(opgave: any): any {
        return {
            ...opgave,
            arbejdsgange: grupper(opgave.arbejdsgange)
        };

        function grupper(arbejdsgange: any[]): any[] {
            const result: any[] = [];
            arbejdsgange.forEach((arbejdsgang) => {
                const prev: any = result[result.length - 1];
                if (arbejdsgang.type !== "ejendomsfaktor") {
                    result.push(arbejdsgang);
                } else if (prev && prev.type === "ejendomsfaktorer") {
                    prev.data.ejendomsfaktorer.push(arbejdsgang.data.ejendomsfaktor);
                } else if (arbejdsgang.data.ejendomsfaktor) {
                    result.push({
                        type: "ejendomsfaktorer",
                        data: {
                            ejendomsfaktorer: [arbejdsgang.data.ejendomsfaktor]
                        }
                    });
                }
            });
            return result;
        }
    }

    public opdelEjendomsfaktorer(opgave: Opgave): any {
        return {
            ...opgave,
            arbejdsgange: opdel(opgave.arbejdsgange)
        };

        function opdel(arbejdsgange: Arbejdsgang[]): any[] {
            const result: any[] = [];
            arbejdsgange.forEach((arbejdsgang) => {
                if (arbejdsgang.type !== "ejendomsfaktorer") {
                    result.push(arbejdsgang);
                } else {
                    (arbejdsgang.data as EjendomsfaktorerData).ejendomsfaktorer.forEach((ejendomsfaktor) => {
                        result.push({
                            type: "ejendomsfaktor",
                            data: {
                                ejendomsfaktor
                            }
                        });
                    });
                }
            });
            return result;
        }
    }

    public dtoToEjendomsfaktorerData(data: any): EjendomsfaktorerData {
        const result: any = {
            ...data,
            ejendomsfaktorer: data.ejendomsfaktorer.map((ejendomsfaktor: any) => ({
                ...ejendomsfaktor,
                status: this.beregnStatus(ejendomsfaktor.status)
            }))
        };
        return result as EjendomsfaktorerData;
    }

    public ejendomsfaktorerDataToDto(data: EjendomsfaktorerData): any {
        const result = {
            ...data,
            ejendomsfaktorer: data.ejendomsfaktorer
        };
        return result;
    }

    public dtoToEjendomsfaktorDefinitioner(dto: EjendomsfaktorDefinitionDto[]): EjendomsfaktorDefinition[] {
        return this.ejendomsfaktorMapper.dtoToEjendomsfaktorDefinitioner(dto);
    }

    private beregnStatus(status: EntitetStatus): EntitetStatus {
        if (status === null || status === undefined) {
            return EntitetStatus.Uaendret;
        }
        return status;
    }
}
